/**
 * An authenticated evidence viewer cannot record accept/reject/verification
 * against an unreadable or missing document. A timer and checked boxes are not
 * evidence that a human has actually seen the file.
 *
 * Read-only presentation gate. This never changes verification or audit data.
 */
export const evidencePreviewReadyForDecision = ({ isLoading, error, previewUrl } = {}) =>
  isLoading === false && !error && Boolean(previewUrl);

export const evidencePreviewFailureMessage = (status) => {
  if (status === 401 || status === 403) {
    return 'You do not have access to inspect this document. Contact an authorised manager. No decision has been recorded.';
  }
  if (status === 404 || status === 410) {
    return 'The saved document could not be retrieved. Check the existing evidence record for recovery or request a current copy. Do not verify a file you cannot inspect.';
  }
  return 'The evidence could not be opened for inspection. Try again later or review the existing record for recovery. No verification has been recorded.';
};
